import { useAuthStore } from '../../contexts/authStore'

export default function ProfileTab() {
  const { user, userType } = useAuthStore()

  return (
    <div className="wc-card wc-elev-sm" style={{ gap: 18 }}>
      <div>
        <h3 className="wc-card-title" style={{ margin: 0 }}>Profilinformationen</h3>
        <p className="wc-muted" style={{ fontSize: 13, margin: '4px 0 0' }}>Ihre persönlichen Informationen</p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div className="wc-field">
          <label>E-Mail-Adresse</label>
          <input type="email" value={user?.email || ''} disabled className="wc-input" style={{ opacity: 0.7 }} />
          <p className="wc-muted" style={{ fontSize: 12, margin: '6px 0 0' }}>Die E-Mail-Adresse kann nicht geändert werden</p>
        </div>

        <div className="wc-field">
          <label>Benutzertyp</label>
          <input
            type="text"
            value={userType === 'admin' ? 'Administrator' : 'Kunde'}
            disabled
            className="wc-input"
            style={{ opacity: 0.7 }}
          />
        </div>

        <div className="wc-alert wc-alert-info" style={{ margin: 0 }}>
          <strong>Hinweis:</strong> Ihre E-Mail-Adresse kann nicht geändert werden. Bei Fragen wenden Sie sich bitte an den Support.
        </div>
      </div>
    </div>
  )
}
